import * as React from "react";
import { useEffect, useState } from "react";
import { Svg } from "@/assets";
import { Button, DropdownMenu } from "@/components/ui";
import { MoreVerticalIcon, StarIcon, Trash2Icon } from "lucide-react";

interface OwnProps {
  uri: string;
  isAutosticker: boolean;
  onDelete: () => void;
  onSetAutosticker: () => void;
}

const StickerCardFC: React.FC<OwnProps> = ({ uri, isAutosticker, onSetAutosticker, onDelete }: OwnProps) => {
  const [thumbnail, setThumbnail] = useState<string | undefined>();

  useEffect(() => {
    if (uri) {
      setThumbnail(uri);
    }
  }, [uri]);

  return (
    <div className="relative w-[100px] h-[100px] bg-slate-100 border border-slate-200 rounded-lg overflow-hidden group hover:shadow-sm transition-all flex items-center justify-center select-none shrink-0">
      <img
        src={thumbnail || Svg.PromptPlaceholder}
        alt="Sticker thumbnail"
        className="w-full h-full object-contain object-center"
      />

      {isAutosticker && (
        <div className="absolute top-1 left-1 bg-yellow-400 text-white rounded-full p-0.5 shadow-sm border border-white z-10 flex items-center justify-center">
          <StarIcon className="size-3 fill-current" />
        </div>
      )}

      <div className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 focus-within:opacity-100 transition-opacity z-10">
        <DropdownMenu>
          <DropdownMenu.Trigger
            render={
              <Button
                variant="outline"
                size="icon-xs"
                className="size-6 bg-white/90 hover:bg-white border border-slate-200 rounded-full shadow-xs flex items-center justify-center"
                onClick={e => e.stopPropagation()}
              >
                <MoreVerticalIcon className="size-3.5 text-slate-500" />
              </Button>
            }
          />
          <DropdownMenu.Content align="end" className="w-44">
            <DropdownMenu.Item onClick={onSetAutosticker} className="flex items-center gap-2">
              <StarIcon className="size-4 text-yellow-500 fill-current" />
              <span>Set as auto-sticker</span>
            </DropdownMenu.Item>
            <DropdownMenu.Item onClick={onDelete} variant="destructive" className="flex items-center gap-2">
              <Trash2Icon className="size-4" />
              <span>Delete</span>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu>
      </div>
    </div>
  );
};

export const SmallStickerCard = StickerCardFC;
